var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('div',{ref:"googleMap",staticClass:"google-map"})])
}
var staticRenderFns = []

export { render, staticRenderFns }